import * as actionTypes from './actionTypes';

// 完全回到initstate
export const setTGRestore = () => ({
    type: actionTypes.SET_TGRESTORE,
});

// 重置選項，若有月曆回到預選第一天
export const setTGReset = () => ({
    type: actionTypes.SET_TGRESET,
});

export const setCalendar = (payload: any) => ({
    type: actionTypes.SET_TGCALENDAR,
    payload,
});

export const setTicketNum = (payload: any) => ({
    type: actionTypes.SET_TGTICKECTNUM,
    payload,
});

export const setSession = (payload: any) => ({
    type: actionTypes.SET_TGSESSION,
    payload,
});

export const setSessionPicked = (payload: any) => ({
    type: actionTypes.SET_TGSESSIONPICKED,
    payload,
});

export const setTotalAmount = (payload: any) => ({
    type: actionTypes.SET_TGTOTALAMOUNT,
    payload,
});

export const setSalePriceSpread = (payload: any) => ({
    type: actionTypes.SET_SALEPRICESPREAD,
    payload,
});

export const setShowCrossellTag = (payload: any) => ({
    type: actionTypes.SET_SHOWCROSSELL,
    payload,
});

export const setGDetail = (payload: any) => ({
    type: actionTypes.SET_TGDETAIL,
    payload,
});

export const setGTempCalendarData = (payload: any) => ({
    type: actionTypes.SET_TGTEMPCALENDARDATA,
    payload,
});

export const setIsTGDSDetailLoading = (payload: any) => ({
    type: actionTypes.SET_ISTGDSDETAILLOADING,
    payload,
});

export const setTGDSDetailFetchFail = (payload: any) => ({
    type: actionTypes.SET_TGDDETAILFETCHFAIL,
    payload,
});

export const setIsTGDSSessionLoading = (payload: any) => ({
    type: actionTypes.SET_ISTGDSSESSIONLOADING,
    payload,
});

export const setTGDSSessionFetchFail = (payload: any) => ({
    type: actionTypes.SET_TGDSSESSIONFETCHFAIL,
    payload,
});

export const setTGNowList = (payload: any) => ({
    type: actionTypes.SET_TGNOWLIST,
    payload,
});

export const setTGNowListData = (payload: any) => ({
    type: actionTypes.SET_TGNOWLISTDATA,
    payload,
});

export const setTGMInfoShow = (payload: any) => ({
    type: actionTypes.SET_TGMINFOSHOW,
    payload,
});

export const setTGCalenderErr = (payload: any) => ({
    type: actionTypes.SET_TGCALENDARERR,
    payload,
});

export const setTGSessionErr = (payload: any) => ({
    type: actionTypes.SET_TGSESSIONERR,
    payload,
});

export const setTGTicketErr = (payload: any) => ({
    type: actionTypes.SET_TGTICKETErr,
    payload,
});

export const setScrollTo = (payload: any) => ({
    type: actionTypes.SET_TGSCROLLTO,
    payload,
});

export const setSubmitWatcher = (payload: any) => ({
    type: actionTypes.SET_TGSUBMITWATCHER,
    payload,
});

export const setIsSubmitSuccess = (payload: any) => ({
    type: actionTypes.SET_ISTGSUBMITSUCCESS,
    payload,
});

export const setTGFinalAbleDates = (payload: any) => ({
    type: actionTypes.SET_TGFINALABLEDATES,
    payload,
});

export const setTGSubmitErrMsg = (payload: any) => ({
    type: actionTypes.SET_TGSUBMITERRMSG,
    payload,
});